import { Injectable } from '@angular/core';
import { ConfigDB } from '../../common/data/config/config';
import { ApiService } from '../services/api.service';
import { Observable, Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Injectable({
    providedIn: 'root'
})
export class CommonService {
    static missingTranslations: any = [];
    public processGroupChange = new Subject<any>();
    public apiProgressChange = new Subject<any>();
    clientKey: number;
    dtsRequestKey: number;
    workflowKey: number;
    offerKey: string;
    versionNo: number;
    policyKey: string;
    endorsementNo: number;
    processKey: number;
    productKey: string;
    departmentKey: number;
    claim: any;
    inputKey: string[];

    process: any;
    policy: any;

    constructor(private configDB: ConfigDB,
                private apiService: ApiService,
                private toasterService: ToastrService) {
    }

    // Configration Layout
    public data = this.configDB.data

    //Function get syscontrol table (SYS2) values for all keys passed as string array 
    public sysControlValues(inputKey): any {

        this.apiService.post("Api/ClientTemplateApi/SysControlValues/", inputKey).subscribe((res) => {

            if (res) return res;

        });
    }

    clearData() {
        this.clientKey = undefined;
        this.dtsRequestKey = undefined;
        this.workflowKey = undefined;
        this.offerKey = undefined;
        this.versionNo = undefined;
        this.policyKey = undefined;
        this.endorsementNo = undefined;
        this.processKey = undefined;
        this.productKey = undefined;
        this.departmentKey = undefined;

        this.claim = undefined;
        this.process = undefined;

        this.inputKey = [];
    }

    copyToClipBoard(val: string) {
        if (!!val) {

            let selBox = document.createElement('textarea');
            selBox.style.position = 'fixed';
            selBox.style.left = '0';
            selBox.style.top = '0';
            selBox.style.opacity = '0';
            selBox.value = val;
            document.body.appendChild(selBox);
            selBox.focus();
            selBox.select();
            document.execCommand('copy');
            document.body.removeChild(selBox);
            this.toasterService.success(`${val} Copied to clipboard`)
        }
    }

    getGroupChangeEvent(): Observable<any> {
        return this.processGroupChange.asObservable();
    }

    getApiProgressChangeEvent(): Observable<any> {
        return this.apiProgressChange.asObservable();
    }
}

